import styled from "@emotion/styled";
import { Spinner } from "@stenajs-webui/elements";

const CIRCUMFERENCE = 283;

export const SteadySpinner = styled(Spinner)`
  will-change: transform;

  circle {
    animation: none;
    stroke-dashoffset: ${CIRCUMFERENCE * 0.75};
  }
`;
